import { endpoints } from 'Constants';

const notificationServices = {
	fetch: (params) => ({
		baseURL: endpoints.NOTIFICATION.FETCH(params.userId),
		method: 'GET',
		params: params?.query,
	}),

	update: (params = {}) => ({
		baseURL: endpoints.NOTIFICATION.UPDATE(params),
		method: 'PUT',
		data: params.data,
	}),
};

export default notificationServices;
